<template>
    <div fluid :class="{ 'slide-filter': isFinished }">
        <div class="filters-heading">
            <span class="filter">
                <i class="fa fa-sliders" />
                <span> Filter </span>
            </span>
            <span class="clear-filter" @click="removeFilterIfPresent">
                <span> Clear filter </span>
                <i class="fa fa-times" />
            </span>
        </div>
        <div class="all-filters-alignment">
            <div role="group" class="all-filters-alignment">
                <label> Search for slide, treatment or patient </label>
                <div>
                    <b-form-input
                        v-model="name"
                        :placeholder="$translate('off_canvas_name')"
                        @keyup.enter="searchSlides"
                    />
                </div>
                <div class="search-case-sensitive">* search is upper/lower case sensitive</div>
            </div>
            <slide-date-filter
                v-if="homePageSelectedView === SLIDE_TIME_ATTRIBUTION.FINISHED"
                opens="left"
                class="adjust-margin"
            />
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import Utils from '../../business/utils/Utils'
import SlideDateFilter from './partials/SlideDateFilter.vue'
import { SLIDE_TIME_ATTRIBUTION } from '../../business/const'

export default {
    components: {
        SlideDateFilter
    },
    data() {
        return {
            name: this.filterText,
            selected: [],
            SLIDE_TIME_ATTRIBUTION
        }
    },
    computed: {
        ...mapState({
            homePageSelectedView: state => state.timelapse.homePageSelectedView,
            filterText: state => state.filter.filterText
        }),
        availableDays() {
            return Utils.getFilterByDayOption(7, 'Day')
        },
        isFinished() {
            return this.homePageSelectedView === SLIDE_TIME_ATTRIBUTION.FINISHED
        }
    },
    watch: {
        homePageSelectedView() {
            this.removeFilterIfPresent()
        }
    },
    async beforeMount() {
        if (this.$route.name === this.$paths.HOME_PAGE) {
            await this.removeFilterIfPresent()
        }
    },
    methods: {
        updateDays() {
            this.$store.commit('filter/filterDays', this.selected)
            this.$store.dispatch('timelapse/setPastSlides')
        },
        removeFilterIfPresent() {
            this.name = ''
            this.$store.commit('filter/changeFilterOption', false)
            this.$store.commit('filter/filterText', '')
            this.$store.commit('timelapse/setPastSlideFilter', null)
            if (this.isFinished) {
                this.$store.dispatch('timelapse/setPastSlides')
            }
        },
        searchSlides() {
            this.$store.commit('filter/filterText', this.name)
            this.$store.dispatch('timelapse/setPastSlides')
        }
    }
}
</script>

<style lang="scss" scoped>
.slide-filter {
    background-color: $dark-3;
    min-height: 90vh;

    .filters-heading {
        padding: 3rem 1rem 1rem 1.4rem;
        display: flex;
        justify-content: space-between;
        border-bottom: 0.3px solid gray;
    }
    i.fa-sliders {
        font-size: 20px;
    }
    i.fa-times {
        opacity: 0;
    }
    input {
        display: initial;
    }
    .filter:hover {
        color: $blue;
    }
    .filter-heading {
        font-size: 1rem;
        color: $light;
        margin-bottom: 0.5rem;
    }
    .clear-filter:hover {
        cursor: pointer;
        color: $blue;
    }
    .clear-filter:hover i.fa-times {
        opacity: 1;
        color: $blue;
    }
    .all-filters-alignment {
        margin: 40px 0 0 6.5px;
        padding: 0 1rem 0 0.3rem;
    }
    .search-case-sensitive {
        color: $light;
        font-size: 10px;
        padding: 0.2rem 0;
        color: $red;
    }
}
</style>
